import { render } from "./Administrativo.vue?vue&type=template&id=6722b15e"
import script from "./Administrativo.vue?vue&type=script&lang=js"
export * from "./Administrativo.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__